import { Link } from "@remix-run/react";

const continents = [
  {
    name: "Europe",
    regions: [{ name: "Sweden", code: "se", flag: "🇸🇪" }],
  },
  {
    name: "North America",
    regions: [{ name: "United States - DEMO - TEST", code: "us", flag: "🇺🇸" }],
  },
];

export default function RegionSelector() {
  return (
    <div className="flex justify-center items-center">
      <div className="bg-white p-8 max-w-lg w-full">
        <h2 className="md:text-2xl font-masonExtendedExtraBold text-gray-800 text-center">
          We're currently not operating in the selected region
        </h2>
        <h3 className="font-proxima text-gray-700 mb-8 mt-2 text-center">
          Choose another region
        </h3>
        <div className="font-masonExtendedBold my-12">
          {continents.map((continent) => (
            <div key={continent.name}>
              <h3 className="text-xl font-semibold text-gray-700 mt-8 border-b pb-2 border-gray-300">
                {continent.name}
              </h3>
              <ul className="font-proxima mt-3">
                {continent.regions.map((region) => (
                  <li key={region.code}>
                    <Link
                      to={`/${region.code}`}
                      className="flex items-center text-black-600 hover:text-black-800 transition duration-200 underline"
                    >
                      <span className="">{region.name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
